import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import DashboardContainer from "routes/admin/DashboardContainer";
import ProductDetailRegister from "./ProductDetailRegister";
import ProductRegisterDetail from "./ProductRegisterDetail";

function ProductRegisterDetailLayout() {
  return (
    <PaddingWrapper padding={10}>
      <ProductRegisterDetail />
    </PaddingWrapper>
  );
}

export default ProductRegisterDetailLayout;
